import React from "react";
import Head from "next/head";
import { GetStaticPaths, GetStaticProps } from "next";
import Layout from "../../components/Layout";
import Page from "../../components/Page";
import { getMainNavigation } from "../../lib/api";
import { usePreviewMode, useStoryblok } from "../../hooks";
import { useRouter } from 'next/router'

import client from "../../api/sdk/clients/apolloClient";
import { getSdk } from "../../api/sdk/getSdk";

const Container = ({data, navigation, preview}) => {

  const previewMode = usePreviewMode(preview);
  const story = useStoryblok(data, preview);

  const router = useRouter();
  const { slug: querySlug } = router.query;

  const {
    background_image,
    background_video,
    body,
    component,
    gallery_images,
    heading,
    lead,
    meta_description,
    meta_keywords,
    title,
    slug,
    anchor_navigation
  } = story.content;

  return (
    <Layout
      backgroundImage={background_image}
      backgroundVideo={background_video}
      galleryImages={gallery_images}
      heading={heading}
      lead={lead}
      navigation={navigation}
      preview={previewMode}
      slug={slug}
      anchorNavigation={anchor_navigation?.[0]}
    >
      <Head>
        <title>{title.replace(/[\[\]']+/g, '').replace(/['"]+/g, '')}</title>
        <meta name="description" content={meta_description} />
        <meta name="keywords" content={meta_keywords} />
      </Head>
      {component === 'Page' && <Page body={body} />}
    </Layout>
  );
};

export const dataSdk = getSdk(client);

const folderName = "vermietungen"

export const getStaticPaths: GetStaticPaths = async () => {
  const links = (await getMainNavigation()) || {};

   const pagesPaths = links.filter(link => link.full_slug.startsWith(folderName)).map((slug: any) => {
     if(slug.full_slug.replace("vermietungen/", "")) {
      return {
        params: { slug: slug.full_slug.replace("vermietungen/", "") },
      }
     }}).filter(item => item);

  return { paths: pagesPaths, fallback: false };
}

export const getStaticProps: GetStaticProps = async ({
  params,
  preview = false,
}) => {
  const data = await dataSdk.getPageItem({slug: `vermietungen/${params.slug}`});
  const navigation = await dataSdk.getMainNavigation();

  return {
    props: {
      data: data.data.PageItem,
      navigation: navigation.data.LayoutItem,
      preview,
    },
    revalidate: 60
  };
};

export default Container;
